"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Paragraph = (0, styled_components_1.default)('p') `
  color: var(--Text, #333);
  font-family: Inter, sans-serif;
  font-size: ${props => props.size || '16px'};
  font-style: normal;
  font-weight: ${props => props.weight || 400};
  line-height: 130%;
`;
